<template>
  <div class="verify-bg">
    <h1>{{ $t('pages.verify-announcement.thank-you', 'Thanks for signing up. Please verify your account.') }}</h1>
    <p>
      {{
        $t(
          'pages.verify-announcement.system-use-caption',
          'To use the {portal} platform, you must verify your account. An email has been sent to {email} with a link to verify your account. If you have not received the email after a few minutes, please check your spam folder.',
          {
            portal: appName,
            email,
          }
        )
      }}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: null
    }
  },
  computed: {
    appName() {
      return process.env.VUE_APP_NAME;
    }
  },
  mounted() {
    if(this.$route.params) {
      this.email = this.$route.params.email;
    } else {
      this.$router.push({ name: 'not-found'});
    }
  }
}
</script>

<style lang="scss" scoped>
  .verify-bg {
    background: #02718c;
    color: white;
    padding: 85px;
    margin: -10px;
  }
</style>
